module.exports = __webpack_public_path__ + "static/productcamp-516335cf8740f5818a838fef22fc4fba.png";